export default "__VITE_ASSET__caKp1p_s__"